<template>
  <div class="white-block">
    <slot></slot>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.white-block {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px;
}
</style>
